import { Alert } from 'quotient-ng-core';

export enum ConfigEnvironments {
    DEV = 'dev',
    QAI = 'qai',
    PROD = 'prod',
    PDN = 'pdn'
}
export interface SSOConfig {
    domain: string;
    cookie: string;
    home: string;
    logout: string;
    login: string;
    issuer: string;
    audience: string;
    appKey: string;
}

export interface CoreConfig {
    host: string;
    port: number;
    serverPort?: number;
    scheme: string;
    corsOrigins: string[];
    fileUploadDest?: string;
    home: string;
    docsPath: string;
    retailerDashboard: string;
}
export interface AppsConfig {
    business: string;
    analytics: string;
    campaigns: string;
    retailer_tools: string;
}

export interface AppConfig {
    core: CoreConfig;
    sso: SSOConfig;
    systemAlerts: Alert[];
    apps: AppsConfig;
    version: string;
    environment: ConfigEnvironments;
}
